import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CanActivate, Router } from "@angular/router";
import { FlashService } from "../../flash/flash.service";
import { ExitFormService } from "../../services/exit-form.service";
import { CustomValidators } from "../../validators/custom-validators.validator";
import { BehaviorSubject } from "rxjs";
import { OffboardingService } from "../../services/offboarding.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

var data = JSON.parse(localStorage.getItem('pd_form'));

@Component({
  selector: "app-exit-form",
  templateUrl: "./exit-form.component.html",
  styleUrls: ["./exit-form.component.css"],
})
export class ExitFormComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private service: ExitFormService,
    private flashService: FlashService,
    private offboardingService : OffboardingService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router
  ) { }

  private status: string;
  private currentUser;

  //form builder
  public form: FormGroup;
  unsubcribe: any
  generate:boolean = false
  private output_data:any = []
  exp_ans = [];
  showform:boolean;
  inValid: boolean = false;
  public elementName = [];
  private user = new BehaviorSubject<any>('');
  castUser = this.user.asObservable();
  public fields: any ;
  public formsStatus: Object = {};
  
  exitForm = new FormGroup({
    full_name: new FormControl("", [Validators.required]),
    address_for_communication: new FormControl("", Validators.required),
    personal_email_id: new FormControl("", [
      Validators.required,
      CustomValidators.vaildEmail,
    ]),
    contact_number: new FormControl("", Validators.required),
    emergency_contact_number: new FormControl("", Validators.required),
  });

  save(status: string) {
    this.status = status;
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.fields = JSON.parse(localStorage.getItem('exit_form'));
    this.getOffboardingEmployeeDetails();

    this.exitForm = this.formBuilder.group({
      account_id: this.currentUser.id,
      name_of_the_employee: new FormControl("", [Validators.required]),
      employee_number: new FormControl("", [Validators.required]),
      date_of_joining: new FormControl("", [Validators.required]),
      resignation_date: new FormControl("", [Validators.required]),
      release_date: new FormControl("", [Validators.required]),
      department: new FormControl("", [Validators.required]),
      what_is_main_reason_for_leaving: new FormControl("", [
        Validators.required,
      ]),
      would_you_work_for_this_employer_again: new FormControl("", [
        Validators.required,
      ]),
      would_you_recommend_this_employer_to_friends_or_family: new FormControl(
        "",
        [Validators.required]
      ),
      what_did_you_enjoy_dislike_about_your_job: new FormControl("", [
        Validators.required,
      ]),
      what_improvements_would_you_suggest_about_your_job_working_conditions_management_support:
        new FormControl("", [Validators.required]),
      what_do_you_think_it_takes_to_succeed_at_this_company: new FormControl(
        "",
        [Validators.required]
      ),
      what_does_your_new_employer_offer_different_to_this_company:
        new FormControl("", [Validators.required]),
      any_other_comments: new FormControl("", [Validators.required]),
      date: new FormControl("", [Validators.required]),
      signature_of_Employee: new FormControl(""),
    });

    this.generateForm();
    this.getpd_answer();
  }

  generateForm(){

     this.form = new FormGroup({
      fields: new FormControl(JSON.stringify(this.fields))
    })
      
    this.form=new FormGroup({});
    this.fields.forEach(x=>{
      if (x.type=='checkbox')
      {
        this.form.addControl(x.name,new FormGroup({}))
        x.options.forEach(o=>{
          (this.form.get(x.name) as FormGroup).addControl(o.key,new FormControl(false))
        })
      }
      else
      {
      this.form.addControl(x.name,
        new FormControl(x.value ||'',x.required?Validators.required:null))
      }
    })
    this.getFields(this.output_data)
  }

  getFields(data) {
    return this.fields
  }

  cc() {
    this.exp_ans = [];

    let keys_data = Object.keys(this.form.value);
    let value_data = Object.values(this.form.value);
    keys_data.forEach((element, index) => {
      var item = this.fields.find((item) => item.name === element);

      if ((typeof value_data[index] === "object") === true) {

        var obj = value_data[index];

        var keys = Object.keys(obj);

        var filtered = keys.filter(function (key) {
          return obj[key];
        });

        this.exp_ans.push({ name: item.name,id: item.id, ans: filtered });
      } else {
        this.exp_ans.push({ name: item.name,id: item.id, ans: value_data[index] });
      }
      if(value_data[index] === undefined){
        return this.inValid = true
     }
    });

    this.inValid = false;
    let obj = Object.values(this.form.value);

    obj.forEach((element) => {
      if (element === "") {
        this.inValid = true;
      }
    });

    this.elementName = [];

    this.exp_ans.forEach(ele => {      
      if(!ele.ans){
        this.elementName.push(ele.name);
       }
    });

    if(this.elementName.length){
      return this.inValid = true
    }

    if(this.inValid === false) {
      this.onSubmit()
    };
  }

   
   editUser(newUser){
     this.user.next(newUser); 
     this.generate = true
   }

  ngDistroy() {
    this.unsubcribe();
  }

   onSubmit() {
    const payload = {
      emp_id: this.currentUser.id.toString(),
      data: this.exp_ans,
    };

    this.spinnerService.show()
       this.service.createExitForm(payload).subscribe(
      (data) => {
        if (data.body["success"]) {
          this.flashService.show(data.body["message"], "alert-success");
          this.getpd_answer();
        } else {
          this.flashService.show(data.body["message"], "alert-success");
          this.getpd_answer();
        }
        this.spinnerService.hide()
        this.getOffboardingEmployeeDetails();
      },
      (err) => {
        this.spinnerService.hide()
        console.log("Create Exit Form Error:", err);
        this.flashService.show(err.error.message["message"], "alert-danger");
      }
    );
  }

  answers:any[]= [];
  tem:any;
  getpd_answer(){
    this.spinnerService.show()
    this.service.getAnswerEx(this.currentUser.id.toString()).subscribe(
      (data) => {
        this.tem = data.body;
        this.answers = this.tem.questions;
        const arr = this.answers
        
        if(arr.length > 0){
          this.showform = false
        }else{
          this.showform = true
        }
        this.spinnerService.hide()
        
      },
      (err) => {
        this.spinnerService.hide()
        console.log("Get Exit Form Answer Error:", err);
      }
    );
  }

  getOffboardingEmployeeDetails(){
    this.spinnerService.show()
    this.offboardingService.getOffboardingEmployeeDetails(this.currentUser.id.toString()).subscribe(
      (data) => {

        this.formsStatus = data.body.data;
        if (this.formsStatus['personal_details_status'] === 'notSubmitted') {
          this.router.navigate(["offboarding/personal-details"]);
        } 
        this.spinnerService.hide()
      },
      (err) => {
        this.spinnerService.hide()
        console.log("Get Offboarding Employee Details Error:", err);
      }
    );
  }
}


// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/offboarding/exit-form/exit-form.component.ts